// Constants for different requests for current reducer
export default {
  activeIRsGroupedByType: 'ACTIVE_IRS_GROUPED_BY_TYPE',
};
